export { StaticDatePicker } from './StaticDatePicker';